import { render } from "./SpanishLuage.vue?vue&type=template&id=7477b41a&scoped=true"
import script from "./SpanishLuage.vue?vue&type=script&lang=js"
export * from "./SpanishLuage.vue?vue&type=script&lang=js"

import "./SpanishLuage.vue?vue&type=style&index=0&id=7477b41a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7477b41a"]])

export default __exports__